import React, { Component } from "react"
import { withStyles } from "@material-ui/core"
import * as constants from "../constants"
import { Cookies } from "react-cookie"
import Grid from "@material-ui/core/Grid"
import Divider from "@material-ui/core/Divider"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import EditIcon from "@material-ui/icons/Edit"
import DeleteIcon from "@material-ui/icons/Delete"
import Snackbar from "@material-ui/core/Snackbar"
import { Alert, AlertTitle } from "@material-ui/lab"
import Select from "react-select";

const styles = (theme) => ({
    button: {
        margin: theme.spacing.unit,
    },
    small: {
        width: theme.spacing(6),
        height: theme.spacing(6),
    },
})

class AccidentSideCovPrice extends Component {
    cookies = new Cookies()
    constructor(props) {
        super(props)

        this.state = {
            AccidentSideCovPrice: this.props.AccidentSideCovPriceData,
            optionsList: this.props.optionSideCovarage,
            visible: true,
            snackstr: "",
            showSnack: false,
            snackMode: "success",
            selectedOption: null,
        }
    }
    componentDidMount() {
        console.log(this.state.AccidentSideCovPrice)

        const { AccidentSideCovPriceData } = this.props;
        const { optionsList } = this.state;

        // پیدا کردن گزینه‌ای که value آن برابر با AccidentSideCovPrice.accident_price_side_coverage_accident_side_coverage_id باشد
        const selectedOption = optionsList.find(option => option.value === AccidentSideCovPriceData.accident_price_side_coverage_accident_side_coverage_id);

        // تنظیم selectedOption در state
        this.setState({ selectedOption });
    }

    handleClickcloseTasckBar = (event) => {
        this.setState({ showSnack: false })
    }

    handleChangeSlideoldMax = (event) => {
        var temparray = this.state.AccidentSideCovPrice
        temparray.accident_price_age_max = event
        this.setState({ AccidentSideCovPrice: temparray })
    }
    // handleOption = (event) => {
    //     var temparray = this.state.AccidentSideCovPrice
    //     temparray.AccidentSideCovPrice2 = event
    //     this.setState({ AccidentSideCovPrice2: temparray })
    // }


    handleSelectChange = (selectedOption) => {
        this.setState({ selectedOption });
        console.log(`Selected: ${selectedOption.value}`);
    };

    handleOp = (selectedSideCovarage) => {
        this.setState({ selectedSideCovarage: selectedSideCovarage }, () => {})
    }

    handleChangeSlideoldMin = (event) => {
        var temparray = this.state.AccidentSideCovPrice
        temparray.accident_price_age_min = event
        this.setState({ AccidentSideCovPrice: temparray })
    }

    handleChangeSlideoldPercent = (event) => {
        var temparray = this.state.AccidentSideCovPrice
        temparray.accident_price_side_coverage_price = event
        this.setState({ AccidentSideCovPrice: temparray })
    }

    modifyNewInstalmentCondition = () => {
        const { AccidentSideCovPrice } = this.state

        console.log(this.state.selectedOption.value)

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "modify_price_side_cov")
        fd.append("accident_price_side_coverage_accident_side_coverage_id", this.state.selectedOption.value)
        fd.append("accident_price_side_coverage_id", AccidentSideCovPrice.accident_price_side_coverage_id)
        fd.append("accident_price_side_coverage_price", AccidentSideCovPrice.accident_price_side_coverage_price)
        // fd.append("accident_price_age_min", AccidentSideCovPrice.accident_price_age_min)
        // fd.append("accident_price_age_max", AccidentSideCovPrice.accident_price_age_max)

        xhttp.open("POST", `${constants.BASE_URL}/accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    deleteInstalmentCondition = () => {
        const { AccidentSideCovPrice } = this.state
        // alert(AccidentSideCovPrice.accident_price_side_coverage_id)

        var self = this
        var xhttp = new XMLHttpRequest()
        xhttp.onreadystatechange = function() {
            if (this.readyState === 4 && this.status === 200) {
                var arr = JSON.parse(this.responseText)
                console.log(arr)
                if (arr.result === "ok") {
                    self.setState({ visible: false, snackstr: arr.desc, showSnack: true, snackMode: "success" })
                } else if (arr.result === "error") {
                    self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                }
            }
        }
        var fd = new FormData()
        fd.append("command", "delete_price_side_cov")

        fd.append("accident_price_side_coverage_id", AccidentSideCovPrice.accident_price_side_coverage_id)
        xhttp.open("POST", `${constants.BASE_URL}/accident`)
        xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
        xhttp.send(fd)
    }

    render() {
        const { classes } = this.props
        const { snackMode, snackstr, showSnack, visible, AccidentSideCovPrice } = this.state
        if (visible) {
            return (
                <Grid container spacing={3}>
                    <Snackbar
                        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                        onClose={this.handleClickcloseTasckBar}
                        open={showSnack}
                        autoHideDuration={10000}
                    >
                        <Alert severity={snackMode}>{snackstr}</Alert>
                    </Snackbar>


                    <Grid item xs={6}>
                        <div>
                            <label className="on">پوشش فرعی حوادث </label>
                            <Select
                                isSearchable={true}
                                className="adapter-txtsize"
                                placeholder={"پوشش فرعی حوادث"}
                                value={this.state.selectedOption}
                                onChange={this.handleSelectChange}
                                options={this.state.optionsList}
                            />
                        </div>
                    </Grid>
                    <Grid item item xs={3}>
                        <FloatingLabelInput
                            type="percent"
                            placeholder="درصد"
                            handleInputt={this.handleChangeSlideoldPercent}
                            value={AccidentSideCovPrice.accident_price_side_coverage_price}
                        />
                    </Grid>


                    {/*<Grid item xs={3}>*/}
                    {/*    <FloatingLabelInput*/}
                    {/*        type="number"*/}
                    {/*        placeholder="از تعداد"*/}
                    {/*        handleInputt={this.handleChangeSlideoldMin}*/}
                    {/*        value={AccidentSideCovPrice.accident_price_age_min}*/}
                    {/*    />*/}
                    {/*</Grid>*/}


                    {/*<Grid item xs={3}>*/}
                    {/*    <FloatingLabelInput*/}
                    {/*        type="number"*/}
                    {/*        placeholder="تا تعداد"*/}
                    {/*        handleInputt={this.handleChangeSlideoldMax}*/}
                    {/*        value={AccidentSideCovPrice.accident_price_age_max}*/}
                    {/*    />*/}
                    {/*</Grid>*/}
                    {/*<Grid item xs={3}>*/}
                    {/*    <FloatingLabelInput*/}
                    {/*        type="percent"*/}
                    {/*        placeholder="درصد"*/}
                    {/*        handleInputt={this.handleChangeSlideoldPercent}*/}
                    {/*        value={AccidentSideCovPrice.accident_price_age_price}*/}
                    {/*    />*/}
                    {/*</Grid>*/}

                    <Grid item xs={3}>
                        <div style={{ width: "100%", textAlign: "left" }}>
                            <Fab
                                className={classes.small}
                                style={{ background: "#44b700" }}
                                aria-label="edit"
                                onClick={this.modifyNewInstalmentCondition}
                            >
                                <EditIcon />
                            </Fab>

                            <Fab className={classes.small} color="secondary" aria-label="edit" onClick={this.deleteInstalmentCondition}>
                                <DeleteIcon />
                            </Fab>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                </Grid>
            )
        } else {
            return null
        }
    }
}
export default withStyles(styles)(AccidentSideCovPrice)
